module.exports = __webpack_public_path__ + "static/scale-model-of-12th-armored-division-memorial-in-abilene-texas-6e55f04dc357a547f5baab151ab689ea.png";